import styled, { css } from 'vue-styled-components';

import theme from '@/config/theme';

const modifiers = {
  arrowPos: {
    bottomLeft: () => css`
      :after {
        border-top: 7px solid ${theme.colors.gray5};
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        content: '';
        position: absolute;
        left: 8px;
      }
    `,
    bottomRight: () => css`
      :after {
        border-top: 7px solid ${theme.colors.gray5};
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        content: '';
        position: absolute;
        right: 8px;
      }
    `,
    topLeft: () => css`
      :before {
        bottom: 100%
        border-bottom: 7px solid ${theme.colors.gray5};
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        content: '';
        position: absolute;
        left: 8px;
      }
    `,
    topRight: () => css`
      :before {
        bottom: 100%
        border-bottom: 7px solid ${theme.colors.gray5};
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        content: '';
        position: absolute;
        right: 8px;
      }
    `,
  },
};

const tooltipProps = {
  arrowPos: String,
  maxWidth: Number,
};

export const ArrowPosition = ['bottomLeft', 'bottomRight', 'topLeft', 'topRight'] as const;

export type TooltipProps = {
  arrowPos: typeof ArrowPosition[number];
  maxWidth: number;
};

export const Wrapper = styled('div', tooltipProps)`
  ${({ maxWidth, arrowPos }: TooltipProps) => css`
    display: inline-block;
    max-width: ${maxWidth}px;
    position: relative;

    ${modifiers.arrowPos[arrowPos]}

    .tooltip {
      align-items: center;
      background: ${theme.colors.gray5};
      border-radius: ${theme.border.radius.xsmall};
      bottom: 0%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      left: 0%;
      padding: 4px 8px;
      position: static;
      right: 0%;
      top: 30%;

      .text {
        align-items: center;
        color: ${theme.colors.white}
        display: flex;
        font-family: ${theme.font.family};
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 20px;
      }
    }
  `}
`;
